<template>
  <div class="total-item-content">
    <div class="total-item-title clear-fix">
      <div class="total-item-up-title">
        <span class="up-title">
            <slot name="up-title"></slot>
        </span>
        <span class="up-number">
           <slot name="up-number"></slot>
        </span>
      </div>
    </div>
    <div class="total-item-number clear-fix">
      <div class="total-item-up-number">
        <span class="up-title">
          <slot name="dn-title"></slot>
        </span>
        <span class="up-number">
          <slot name="dn-number"></slot>
        </span>
         <div class="item_rt"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
 .total-item-content:nth-child(1){
   height:40px;
   line-height:40px;
 }
 .total-item-content:nth-child(2){
   height:40px;
   line-height:40px;
   background-color:#222120!important;
 }
 .total-item-content:nth-child(3){
   height:40px;
   line-height:40px;
   background-color:#222120!important;
 }
 .total-item-content:nth-child(4){
   height:40px;
   line-height:40px;
   background-color:#222120!important;
 }
 .total-item-content:nth-child(5){
   height:40px;
   line-height:40px;
   background-color:#222120!important;
 }
 .total-item-content:nth-child(6){
   height:40px;
   line-height:40px;
   background-color:#222120!important;
 }
.total-item-content {
  width: 100%;
  font-size: 16px;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
  .total-item-title {
    float: left;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
  }
  .total-item-up-title {
    float: left;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Light;
    font-weight: 300;
    text-align: center;
    color: #ffffff;
    .up-title{
      float: left;
      padding-left: 10px;
    }
    .up-number{
      float: left;
      padding-left: 10px;
    }
  }
  .total-item-up-number {
    position: relative;
    float: right;
    font-size: 20px;
    margin-right: 30px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    .up-title{
      float: right;
    }
    .up-number{
      float: left;
    }
  }
  .total-item-number {
    padding-bottom: 10px;
    font-family: Source Han Sans CN;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
  }
  .item_rt{
    position:absolute;
    right:-28px;
    margin-top:10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
    transform: rotate(180deg); /*顺时针旋转90°*/
  }
}
</style>